(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/fraction-payment.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/fraction-payment.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useLocation,
  useHistory
} = ReactRouterDOM;
const {
  useCallback,
  useContext,
  useEffect,
  useState,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  ReactButton: Button
} = svs.ui;
const {
  form,
  format
} = svs.utils;
const {
  getPurchasedFractionsForCurrentMember
} = svs.components.marketplaceData.selectors.games;
const {
  usePrevious
} = svs.components.lbUtils.usePrevious;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const {
  payCoOpFractions
} = svs.components.marketplaceData.fractionPayment.actions;
const {
  trackEvent
} = svs.components.analytics;
const {
  CoOpContext
} = svs.components.tipsen;
const {
  QS_FRACTION_DATA
} = svs.components.marketplaceShared.sharedConstants.constants;
const getDiffDateFromNow = date => date.getTime() - Date.now();
const FractionPayment = _ref => {
  let {
    activatedDrawId,
    className,
    game,
    groupId,
    isSmall
  } = _ref;
  const check = useRef();
  const btnRef = useRef(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const isCurrentUserAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const fractionPurchaseLoading = useSelector(state => {
    var _state$FractionPaymen;
    return state === null || state === void 0 || (_state$FractionPaymen = state.FractionPayment) === null || _state$FractionPaymen === void 0 ? void 0 : _state$FractionPaymen.fractionPurchaseLoading;
  });
  const termsUrl = "/dokument/".concat(svs.tipsen.data.marketplaceDocumentId.doucumentId);
  const returnUrlQuery = "".concat(QS_FRACTION_DATA, "=").concat(activatedDrawId, "_").concat(groupId);
  const returnUrl = !isCurrentUserAuthenticated ? "".concat(window.location.pathname, "?").concat(returnUrlQuery) : null;
  const searchParams = new URLSearchParams(location.search);
  const marketplaceFractionData = searchParams.get(QS_FRACTION_DATA);
  const params = (marketplaceFractionData === null || marketplaceFractionData === void 0 ? void 0 : marketplaceFractionData.split('_')) || [];
  const {
    setActive
  } = useContext(CoOpContext);
  const {
    buyStop,
    fractionPrice,
    isSoldOut,
    isSubmitted,
    maxFractions,
    maxFractionsPerMember
  } = game;
  const [state, setState] = useState({
    isBeforeBuyStop: getDiffDateFromNow(buyStop) > 0,
    buyStop,
    disabledBuyButton: false
  });
  const currentPurchasedFractions = useSelector(state => getPurchasedFractionsForCurrentMember(state, {
    activatedDrawId,
    groupId
  }));
  const hasReachedMaxFractionsPerMember = currentPurchasedFractions > (maxFractionsPerMember || maxFractions);
  const previousBuyStop = usePrevious(buyStop);
  const passedBuyStopTimer = useRef(null);
  const setTimeoutForBuyStop = useCallback(callback => {
    passedBuyStopTimer.current = setTimeout(callback, getDiffDateFromNow(state.buyStop));
  }, [state.buyStop]);
  const handlePassBuyStop = () => setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
    isBeforeBuyStop: false
  }));
  const cantBuy = () => hasReachedMaxFractionsPerMember || isSoldOut || !state.isBeforeBuyStop || fractionPurchaseLoading || Boolean(isSubmitted) || state.disabledBuyButton;
  const getDialogOptions = (fractionPrice, termsUrl, callback, obligatoryCallback) => {
    const title = 'Betala';
    const text = "Vill du betala ".concat(fractionPrice, " kr f\xF6r 1 andel i spelet? <br /><br />Om spelet inte l\xE4mnas in eller om det avbryts f\xE5r du pengarna tillbaka.<br /><br />Genom att k\xF6pa en andel godk\xE4nner du <a href=\"").concat(termsUrl, "\" rel=\"noopener noreferrer\" target=\"_BLANK\">Villkor f\xF6r att Spela tillsammans</a>.");
    const buttons = [{
      text: 'Avbryt',
      classes: {
        inverted: true
      },
      callback: () => {
        obligatoryCallback();
      }
    }, {
      text: 'Betala',
      classes: {
        focus: true
      },
      callback: () => {
        obligatoryCallback();
        callback();
      },
      showLoader: true
    }];
    return {
      title,
      text,
      buttons,
      icon: 'games'
    };
  };
  const handleCheckAccountBalance = callback => {
    svs.components.marketplaceData.fractionPayment.services.fetchAccountBalance((error, balance) => callback(error, balance));
  };
  const handleDialogPayClick = () => dispatch(payCoOpFractions(groupId, activatedDrawId, game));
  const handleCheckPlayerTimelimits = async cb => {
    const timeLimitData = await svs.accountServices.player_timelimits.getPlayerTimeLimits();
    if (timeLimitData && (timeLimitData.day.remaining === '0' || timeLimitData.week.remaining === '0' || timeLimitData.month.remaining === '0')) {
      cb(true);
      return;
    }
    cb(false);
  };
  const showPaymentDialog = () => {
    const obligatoryCallback = () => {
      requestAnimationFrame(() => {
        btnRef.current.classList.remove('has-focus');
      });
      if (check.current) {
        setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
          disabledBuyButton: false
        }));
      }
      return false;
    };
    dispatch(showDialog(getDialogOptions(fractionPrice, termsUrl, handleDialogPayClick, obligatoryCallback)));
  };
  const handleShowTransferDialog = (_ref2, callback) => {
    let {
      balance,
      fractionPrice,
      message
    } = _ref2;
    const msg = message || 'Du har inte tillräckligt med pengar på ditt spelkonto.';
    const text = "<p>Ditt saldo: ".concat(format.Currency(balance), " kr<br />Andelspris: ").concat(format.Currency(fractionPrice), " kr</p>");
    const buttons = [{
      text: 'Avbryt',
      classes: {
        inverted: true
      }
    }, {
      text: 'Sätt in',
      classes: {
        focus: true
      },
      callback
    }];
    dispatch(showDialog({
      title: msg,
      text,
      buttons,
      icon: 'balance'
    }));
  };
  const handleNavigateToTransfer = () => {
    form.postToUrl(svs.core.urlMapping.get('transactionsHome'), {
      returnUrl: window.location.href
    });
  };
  const handleOnPayButtonClick = () => {
    setActive({
      groupId,
      activatedDrawId
    });
    btnRef.current.classList.add('has-focus');
    btnRef.current.focus();
    trackEvent({
      category: 'Andelsspel produktsida',
      action: 'CTA andelsspel',
      opt_label: 'Köp 1 andel'
    });
    if (!isCurrentUserAuthenticated) {
      window.history.pushState(null, '', returnUrl);
      return svs.components.customer_login.login();
    }
    setState(prev => _objectSpread(_objectSpread({}, prev), {}, {
      disabledBuyButton: true
    }));
    handleCheckPlayerTimelimits(hasReachedLimit => {
      if (hasReachedLimit) {
        const {
          title,
          text,
          buttons,
          icon
        } = svs.components.marketplaceShared.specificDialogs.dialogs.timelimitDialog;
        dispatch(showDialog({
          title,
          text,
          buttons,
          icon
        }));
      } else {
        handleCheckAccountBalance((error, balance) => {
          if (error) {
            dispatch(showDialog({
              title: 'Det gick inte att hämta saldot.',
              type: 'error'
            }));
            return;
          }
          if (balance < parseInt(fractionPrice, 10)) {
            return handleShowTransferDialog({
              balance,
              fractionPrice,
              message: 'Du har inte tillräckligt med pengar på ditt spelkonto för att köpa en andel.'
            }, handleNavigateToTransfer);
          }
          showPaymentDialog();
        });
      }
    });
  };
  const getButtonLabel = () => {
    if (isSoldOut) {
      return 'Slutsåld';
    }
    return !fractionPurchaseLoading ? 'Köp 1 andel' : 'Betalar..';
  };
  useEffect(() => {
    var _btnRef$current;
    if ((_btnRef$current = btnRef.current) !== null && _btnRef$current !== void 0 && _btnRef$current.classList.contains('has-focus')) {
      btnRef.current.focus();
    }
    check.current = true;
    return () => {
      check.current = false;
    };
  });
  const payButton = (() => React.createElement("div", {
    className: "qa-pay-fraction-button"
  }, React.createElement(Button, {
    block: true,
    className: "qa-pay-fraction-button",
    disabled: cantBuy(),
    elemRef: btnRef,
    onClick: handleOnPayButtonClick,
    size: isSmall ? 100 : 300
  }, getButtonLabel())))();
  if (state.isBeforeBuyStop) {
    setTimeoutForBuyStop(handlePassBuyStop);
  }
  useEffect(() => {
    if (buyStop !== previousBuyStop && getDiffDateFromNow(buyStop) > 0) {
      setTimeoutForBuyStop(handlePassBuyStop);
    }
    return () => clearTimeout(passedBuyStopTimer.current);
  }, [buyStop, previousBuyStop, setTimeoutForBuyStop]);
  useEffect(() => {
    const queryActivatedDrawId = params[0];
    const queryGroupId = params[1];
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete(QS_FRACTION_DATA);
    if (isCurrentUserAuthenticated && queryActivatedDrawId && queryGroupId) {
      if (parseInt(queryActivatedDrawId, 10) === activatedDrawId && parseInt(queryGroupId, 10) === groupId) {
        history.replace({
          search: queryParams.toString()
        });
        showPaymentDialog();
      }
    }
  }, [activatedDrawId, groupId]);
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    id: "snackbar-selector"
  }, payButton));
};
FractionPayment.defaultProps = {
  className: '',
  isSmall: false
};
setGlobal('svs.components.tipsen.FractionPayment', FractionPayment);

 })(window);